import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import "./global.scss";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Amplify, ResourcesConfig } from 'aws-amplify';
import { config } from './config/config';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Example color
    },
  },
});

const authConfig: ResourcesConfig['Auth'] = {
  Cognito: {
    userPoolId: config.amplifyConfig.userPoolId!,
    userPoolClientId: config.amplifyConfig.userPoolClientId!,
  }
};

Amplify.configure({
  Auth: authConfig
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>;
    </React.StrictMode>
  </BrowserRouter>
  
);
